import { Link, NavLink } from "react-router-dom";
import Brand from "./../Assets/Images/Brand.svg";
import { useEffect, useState } from "react";

export default function Header() {

    const [scrolled, setScrolled] = useState<boolean>(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <header className={`navbar navbar-expand-lg ${scrolled ? "" : "navbar-transparent"} py-3 sticky-top`}>
            <div className="container px-lg-0">

                <Link className="navbar-brand navbar-brand-autodark" to={"/"}>
                    <img
                        src={Brand}
                        alt="LineXS"
                        className="navbar-brand-image"
                        title="LineXS"
                        style={{ height: "2.8rem" }}
                    />
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarTogglerDemo01"
                    aria-controls="navbarTogglerDemo01"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                    <nav className="navbar-nav ms-auto">

                        <div className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/">
                                <span className="nav-link-title">Início</span>
                            </NavLink>
                        </div>

                        <div className="nav-item">
                            <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/planos">
                                <span className="nav-link-title">Planos</span>
                            </NavLink>
                        </div>

                        <div className="nav-item mt-3 mt-lg-0 ms-lg-5">
                            <a href="#" className="btn btn-primary">
                                Experimente Grátis
                            </a>
                        </div>

                    </nav>
                </div>
            </div>
        </header>

    )
}